module.exports = {
  loadingButton: (color) => {
    if (!color) {
      color = 'light'
    }
    return `<img src="${appURL}/images/three-dots--${color}.svg" class="u-loading u-loading--button" alt-text="Loading" />`
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers.js